interface Props {
  size?: number;
  color?: string;
}

export const SendIcon = ({size = 24, color = '#8A8478'}: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g clipPath="url(#send-clip)">
      <path
        d={
          'M4.01 6.03L11.52 9.25L4 8.25L4.01 6.03Z' +
          'M11.51 14.75L4 17.97V15.75L11.51 14.75Z' +
          'M2.01 3L2 10L17 12L2 14L2.01 21L23 12L2.01 3Z'
        }
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="send-clip">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
